export enum NetErrorType {
  serverErr = 'serverErr',
  clientErr = 'clientErr',
}

export class NetError extends Error {
  netErrType: NetErrorType;

  netErrMsg: string;

  constructor(msg: string, type: NetErrorType) {
    super();
    this.netErrMsg = msg;
    this.netErrType = type;
  }
}
